document.addEventListener('octane.quiz.completed', function (e) {
    var sections = document.querySelectorAll('.shopify-section');
    for (var i = 0; i < sections.length; i++) {
        sections[i].style.display = 'block';
    }

    // Get all elements with the class .oct-quiz-result-item__title
    const elements = document.querySelectorAll('.oct-quiz-result-item__title');

    // Find the tallest element
    let maxHeight = 0;
    for (let i = 0; i < elements.length; i++) {
    if (elements[i].clientHeight > maxHeight) {
        maxHeight = elements[i].clientHeight;
    }
    }

    // Set the height of all elements to the tallest element's height
    for (let i = 0; i < elements.length; i++) {
    elements[i].style.height = maxHeight + 'px';
    }

    requestAnimationFrame(scrollToTopStepFunction);
    // get the html within the element with the class .oct-quiz-resultWrapper>.oct-quiz-rich-text
    const protip = document.querySelector('.oct-quiz-rich-text p');
    // replace the html within the element .image-with-text__text with the protip
    document.querySelector('.image-with-text__text').innerHTML = protip.innerText;
    // hide the protip
    protip.style.display = 'none';
}, false);


function scrollToTop() {
  const scrollToTopDuration = 500; // Duration of the scroll animation in milliseconds
  const scrollToTopStep = -window.scrollY / (scrollToTopDuration / 15); // Amount to scroll on each step

  function scrollToTopStepFunction() {
    if (window.scrollY !== 0) {
      window.scrollBy(0, scrollToTopStep);
      requestAnimationFrame(scrollToTopStepFunction);
    }
  }

  requestAnimationFrame(scrollToTopStepFunction);
}


//  on document load, hide all the .spaced-section except the second one
// document.addEventListener('DOMContentLoaded', function () {
//     var sections = document.querySelectorAll('.spaced-section');
//     for (var i = 0; i < sections.length; i++) {
//         sections[i].style.display = 'none';
//     }
//     sections[1].style.display = 'block';
// }
// , false);
